export default class CompetitorRecord {
  constructor (data) {
    this.id = data.id
    this.name = data.nameFr
    this.shortname = data.shortnameFr
  }
}
